import { EXTRA_FINANCE_PLANING_OPTIONS } from './types';

export const refinancingQuestions: Record<string, any> = {
  propertyWorth: {
    labelKey: 'applicationForm.REFINANCING.propertyWorth.label',
  },
  refinanceAmount: {
    labelKey: 'applicationForm.REFINANCING.refinanceAmount.label',
    explanationKey: 'applicationForm.REFINANCING.refinanceAmount.explanation',
  },
  outstandingCurrentMortgage: {
    labelKey: 'applicationForm.REFINANCING.outstandingCurrentMortgage.label',
    explanationKey: 'applicationForm.REFINANCING.outstandingCurrentMortgage.explanation',
  },
  extraFinancePlanning: {
    labelKey: 'applicationForm.REFINANCING.extraFinancePlanning.label',
    explanationKey: 'applicationForm.REFINANCING.extraFinancePlanning.explanation',
    options: EXTRA_FINANCE_PLANING_OPTIONS.map(option => ({ label: option, value: option })),
  },
};
